// src/Hooks/usePayments.ts

import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { paymentService } from "../Api/services/paymentService";
import { Payment } from "../Types/PaymentManagement";

export const usePayments = () => {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleError = (err: unknown, defaultMessage: string) => {
    if (err instanceof AxiosError) {
      const errorResponse = err.response?.data as {
        message?: string;
        errors?: {
          issues?: Array<{
            code: string;
            expected: string;
            received: string;
            path: string[];
            message: string;
          }>;
          name?: string;
        };
        statusCode?: number;
      };

      if (
        errorResponse?.errors?.name === "ZodError" &&
        errorResponse.errors.issues
      ) {
        const zodErrorMessage = errorResponse.errors.issues
          .map(
            (issue) => `Field ${issue.path.join(".")} error: ${issue.message}`
          )
          .join(", ");

        setError(`Validation Error: ${zodErrorMessage}`);
      } else {
        setError(errorResponse?.message || err.message || defaultMessage);
      }
    } else {
      setError(defaultMessage);
    }
  };

  // Add the postPayment function
  const sendPaymentLink = async (id: string) => {
    setLoading(true);
    try {
      const response = await paymentService.postPayment(id);
      // Optionally update the payments list or handle the response as needed
      setError(null);
      return response.data;
    } catch (err) {
      handleError(err, "Failed to post payment");
      return null;
    } finally {
      setLoading(false);
    }
  };

  const sendProductPaymentLink = async (id: string, type: string) => {
    setLoading(true);
    try {
      const response = await paymentService.postRentalPayment(id, type);
      // Optionally update the payments list or handle the response as needed
      setError(null);
      return response.data;
    } catch (err) {
      handleError(err, "Failed to post payment");
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    payments,
    loading,
    error,

    sendPaymentLink,
    sendProductPaymentLink,
  };
};
